<template>
    <Pill :variant="variant" :icon="icon" :label="label" size="sm" />
</template>

<script setup>
    import { computed } from 'vue';

    import Pill from '@/modules/admin/ui/Pill.vue';

    /**
     * Espejo del enum del backend (`Evento::BORRADOR/PUBLICADO/CANCELADO/
     * APLAZADO`) y del select "Estado" del formulario de evento. El estado
     * del evento no es un booleano activo/pausado: "Pausado" no existe en el
     * dominio, y 0 (Borrador) es el valor con el que nace un evento nuevo.
     */
    const ESTADOS = {
        0: {
            label: 'Borrador',
            icon: 'fas fa-pen',
            variant: 'amber'
        },
        1: {
            label: 'Publicado',
            icon: 'fas fa-check',
            variant: 'emerald'
        },
        2: {
            label: 'Cancelado',
            icon: 'fas fa-times',
            variant: 'red'
        },
        3: {
            label: 'Aplazado',
            icon: 'fas fa-clock',
            variant: 'blue'
        }
    };

    const props = defineProps({
        /**
         * Event status: 0 = draft, 1 = published, 2 = cancelled,
         * 3 = postponed.
         */
        status: {
            type: [Number, String],
            default: 0
        }
    });

    // Un valor desconocido se pinta como Borrador (el estado menos expuesto
    // en el front) en vez de inventar un "Pausado" que el backend no tiene.
    const estado = computed(() => ESTADOS[Number(props.status)] || ESTADOS[0]);

    const label = computed(() => estado.value.label);

    const icon = computed(() => estado.value.icon);

    const variant = computed(() => estado.value.variant);
</script>
